<template>
    <div class="ses-modal-wrap" v-if="floordata" id="DoorFloorInfo">
        <a class="ses-modal-bd" @click="closeModal"></a>
        <div class="ses-modal" style="width: 1320px;">
            <div class="ses-modal-head"> Floor Information</div>
            <div class="ses-modal-body">
                <form id="floor-form" >
                    <input type="hidden" v-model="reseter.counter">
                    <input type="hidden" v-model="step">
                    <table id="floor-table">
                        <thead>
                            <tr>
                                <th>Floor #</th>
                                <th style="width:86px;">Duplicate To</th>

                                <th style="width: 66px;">Floor to Floor Height <small>(in) (range: 96-360)</small></th>
                                <th>Wall Material</th>

                                <th style="width: 66px;">Front Wall Thickness <small>(in) (range: 0-99)</small> <ses-tooltip type="illu-ds3"></ses-tooltip> A1</th>
                                <th>Front Entrance Finish</th>
                                <th style="width:86px;">Powder Coat <br>Color Code<br><ses-tooltip type="illu-idec"></ses-tooltip></th>

                                <th>Front <br>Opening Direction <ses-tooltip type="illu-ds5" align="right"></ses-tooltip></th>

                                <th style="width: 66px;">Rear/Side Wall Thickness <small>(in) (range: 0-99)</small> <ses-tooltip type="illu-ds3" align="right"></ses-tooltip> A4</th>
                                <th>Rear/Side Entrance Finish</th>
                                <th style="width:86px;">Powder Coat <br>Color Code<br><ses-tooltip type="illu-idec" align="right"></ses-tooltip></th>

                                <th>Rear/Side <br>Opening Direction <ses-tooltip type="illu-ds5" align="right"></ses-tooltip></th>
                            </tr>
                        </thead>
                        <tbody id="floor-info-list">
                            <tr v-for="(floor,f) in floors" :key="f">
                                <td class="flr-num">{{ f+1 }}</td>
                                <td class="flr-short">
                                    <select v-model="duplicator[f]" @change="duplicate(f,duplicator[f])">
                                        <option value="">Floor #</option>
                                        <option value="all">All Floors</option>
                                        <option :value="f" :data-d="d" v-for="(d,f) in duplicator" :key="f">Floor {{ parseInt(f) + 1 }}</option>
                                    </select>
                                </td>

                                <td class="flr-marking"><input type="number" v-model="floor.floor_height" ref="floor_height" required @blur="rangeCheck(f,'floor_height',96,360)"></td>
                                <td class="flr-short">
                                    <select v-model="floor.wall_material">
                                        <option>Drywall</option>
                                        <option>Concrete</option>
                                        <option>Masonry</option>
                                    </select>
                                </td>

                                <td class="flr-marking"><input type="number" v-model="floor.fr_wall_thickness" ref="fr_wall_thickness" required @blur="rangeCheck(f,'fr_wall_thickness',0,99)"></td>
                                <td class="flr-short">
                                    <select v-model="floor.fr_frame_finish" @change="reset(); floor.fr_powder_color = '';">
                                        <option value="Prime">Prime</option>
                                        <option value="Stainless Steel">Stainless Steel</option>
                                        <option value="Powder Coat">Powder Coat</option>
                                    </select>
                                </td>
                                <td class="flr-marking"><input type="text" v-model="floor.fr_powder_color" ref="fr_powder_color" required :disabled="floor.fr_frame_finish != 'Powder Coat'"></td>

                                <td class="flr-short">
                                    <select v-model="floor.fr_opening" @change="changeOpening(floor.fr_opening,'fr_opening',f)" required ref="fr_opening">
                                        <option>None</option>
                                        <option v-if="floordata.door.door_op_fr_w != '48'">Left</option>
                                        <option>Center</option>
                                        <option v-if="floordata.door.door_op_fr_w != '48'">Right</option>
                                    </select>
                                </td>

                                <td class="flr-marking">
                                    <input type="text" v-model="floor.rear_wall_thickness" ref="rear_wall_thickness" required :disabled="!rear" @blur="rangeCheck(f,'rear_wall_thickness',0,99)">
                                </td>
                                <td class="flr-short">
                                    <select v-model="floor.rear_frame_finish" :disabled="!rear" @change="reset(); floor.rear_powder_color = '';">
                                        <option value="Prime">Prime</option>
                                        <option value="Stainless Steel">Stainless Steel</option>
                                        <option value="Powder Coat">Powder Coat</option>
                                    </select>
                                </td>
                                <td class="flr-marking">
                                    <input type="text" v-model="floor.rear_powder_color" ref="rear_powder_color" required 
                                        :disabled="!rear || floor.rear_frame_finish != 'Powder Coat'">
                                </td>

                                <td class="flr-short">
                                    <select v-model="floor.rear_opening" @change="changeOpening(floor.rear_opening,'rear_opening',f)" :disabled="!rear" required ref="rear_opening">
                                        <option>None</option>
                                        <option v-if="floordata.door.door_op_rear_w != '48'">Left</option>
                                        <option>Center</option>
                                        <option v-if="floordata.door.door_op_rear_w != '48'">Right</option>
                                    </select>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </form>
            </div>
            <div class="ses-modal-foot">
                <a class="btn btn-black" @click="saveFloors">Save Info</a>
            </div>
        </div>
    </div>
</template>
<script>

  export default {
    name: "doorfloorInfo",
    props: {
      floordata: {
        type: [String, Object, Array, Boolean],
        default: "",
        description: "Model"
      },
    },
    data() {
      return {
        step: 1,
        toggled: false,
        rear: false,
        reseter: { counter : 1 },
        duplicator: {},
        floors: [],
        floor: {
            car_num : 1,
            floor_no : 1,
            floor_height : '',
            wall_material : '',
            fr_wall_thickness : '',
            fr_frame_finish : '',
            fr_powder_color : '',
            fr_landing_finish : '',
            fr_landing_powder_color : '',
            rear_wall_thickness : '',
            rear_frame_finish : '',
            rear_powder_color : '',
            rear_landing_finish : '',
            rear_landing_powder_color : '',
        }
      };
    },
    watch: {
        floordata: {
            handler: function(data) {
                var i = 0;
                if ( data ) {
                    if ( data.door.floor_info ) {
                        var floors = data.door.floor_info;

                        if ( floors.length > data.door.no_of_floors ) {
                            floors.splice(data.door.no_of_floors,floors.length-data.door.no_of_floors);
                        } else if ( floors.length < data.door.no_of_floors ) {
                            for (i = floors.length; i < data.door.no_of_floors; i++) {
                                floors[i] = { ...this.floor, ...{ car_num : data.cn, floor_no : i+1 } };
                            }
                        }

                        this.floors = floors;

                    } else {
                        this.floors = [];
                        for (var f = 0; f < data.door.no_of_floors; f++) {
                            this.floors[f] = { ...this.floor, ...{ car_num : this.floordata.cn, floor_no : f+1 } };
                        }
                    }

                    // for ( var fn in this.floors ) {
                    //     this.floors[fn].fr_opening = data.door.door_op_fr_opening;
                    //     this.floors[fn].rear_opening = data.door.door_op_rear_opening;
                    // }

                    this.rear = data.door.entrance_rear_opening_w && data.door.entrance_rear_opening_w != 'N/A';

                    for (i = 0; i < data.door.no_of_floors; i++) {
                        this.duplicator[i] = '';
                    }
                }

            },
            deep: true
        }
    }, 
    methods: {
        checkData(){
            var hasEmpty = false,
                firstEl = false,
                item = false;

            for(var i in this.$refs) {
                const _el = this.$refs[i];
                if ( Array.isArray(_el) ) {
                    for (var x in _el) {
                        item = _el[x];
                        if ( item && !item.disabled && item.value == '' ) {
                            hasEmpty = true;
                            if ( !firstEl ) firstEl = item;
                        }
                    }
                } else {
                    item = _el;
                    if ( item && !item.disabled && item.value == '' ) {
                        hasEmpty = true;
                        if ( !firstEl ) firstEl = item;
                    }
                }
            }

            Array.from(document.querySelectorAll('.has-error')).forEach(function(el) { 
                el.classList.remove('has-error');
            });

            if ( hasEmpty ) {
                alert('Please fill all required data.');
                firstEl.focus();
                firstEl.classList.add('has-error');
                return false;
            }
            return true;
        },
        changeOpening(val,key,f){
            if ( f == 0 && val && val != 'None' ) {
                for ( var fn in this.floors ) {
                    this.floors[fn][key] = val;
                }
                if ( key == 'fr_opening' ) this.floordata.door.door_op_fr_opening = val;
                if ( key == 'rear_opening' ) this.floordata.door.door_op_rear_opening = val;
            }

            this.reset();
        },
        rangeCheck(f,key,min,max){
            var out_of_range = false,
                item = this.floors[f][key];

            if ( item != '' && item < min ) out_of_range = true;
            if ( item > parseInt(max) ) out_of_range = true;
            
            if ( out_of_range ) {
                alert('Number you entered is Out of Range.');
                this.floors[f][key] = '';
                this.$refs[key][f].focus();
            }

            this.reset();
        },
        duplicate(f, d){
            if ( d == 'all' ) {
                for (var i = 0; i < this.floordata.door.no_of_floors; i++) {
                    this.floors[i] = { ...{}, ...this.floors[f]};
                }
            } else {
                this.floors[d] = { ...{}, ...this.floors[f]};
            }
            this.duplicator[f] = '';
            this.reset();
        },
        reset(){
            var ctr = this.reseter.counter;
            this.$set(this.reseter,'counter',ctr+2);
            this.$set(this.reseter,'counter',ctr+1);
        },
        closeModal() {
            if ( confirm('Data changes will be lost if not saved.') ) {
                this.$emit('closeinfo');
            }
        },
        showItems() {
            ++this.step;
        },
        saveFloors() {
            if ( !this.checkData() ) return false;

            this.$emit('saveinfo', {
                cn : this.floordata.cn,
                door : { ...this.floordata.door, ...{ floor_info : this.floors } }
            });

            this.$emit('closeinfo');
        }
    }
};
</script>
<style>
    .ses-modal-wrap { position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; z-index: 99999; }
    .ses-modal-bd { position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,.5); }
    .ses-modal { position: absolute; top: 50%; left: 50%; width: 940px; max-width: calc(100% - 60px); height: auto; transform: translate(-50%,-50%); background: #FFF; border-radius: 6px; overflow: hidden; }
    .ses-modal-head { color: #fff; font-size: 19px; text-shadow: 1px 1px 3px #000; text-align: center; background: #333; padding: 14px 20px; min-height: 16.43px; }
    .ses-modal-body { position: relative; padding: 15px; max-height: calc(100vh - 160px); overflow: auto;}
    .ses-modal-foot { padding: 15px; text-align: right; border-top: 1px solid #e5e5e5; }
    .modal-step { padding: 0 15px; }

    #DoorFloorInfo .ses-modal-body { min-height: 530px; }
    #DoorFloorInfo table { width: 100%; }
    #DoorFloorInfo th { font-size: 12px; position: relative; }
    #DoorFloorInfo th, #DoorFloorInfo td { padding: 4px 10px; border: 1px solid #333; width: auto; }
    #DoorFloorInfo thead th, #DoorFloorInfo tbody td { text-align: center; }
    #DoorFloorInfo table input[type="text"],
    #DoorFloorInfo table input[type="number"],
    #DoorFloorInfo table select,
    #DoorFloorInfo table textarea { width: calc(100% + 22px); border-radius: 0px !important; box-shadow: none; border: 1px solid #333; margin: -5px -11px; padding: 4px 10px; display: block; height: 26px; }
    #DoorFloorInfo table textarea { resize: vertical; min-height: 64px; }
    #DoorFloorInfo table label { display: inline-block; margin: -4px 4px; font-weight: normal; }
    #DoorFloorInfo table [disabled] { background: #b5b5b5 !important; opacity: 1 !important; }
    #DoorFloorInfo .has-error{ outline: 1px solid red !important; z-index: 2 !important; background: #ffe9e9 !important; border-color: red !important; }
</style>